module.exports = __webpack_public_path__ + "static/media/Icon_Small_Arrow.e4e993a4.svg";